var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconThermometerCold = function SvgIconThermometerCold(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.18 3.305a2.75 2.75 0 0 1 4.695 1.945v9.263a1 1 0 0 0 .23.639 3.875 3.875 0 1 1-5.96 0 1 1 0 0 0 .23-.64V5.25c0-.73.29-1.429.805-1.945M10.125.5a4.75 4.75 0 0 0-4.75 4.75v8.92a5.875 5.875 0 1 0 9.5 0V5.25A4.75 4.75 0 0 0 10.125.5m9.75 3a1 1 0 0 1 1 1v1.623l1.54-.502a1 1 0 0 1 .62 1.902l-1.543.502.955 1.316a1 1 0 0 1-1.619 1.175l-.953-1.314-.953 1.314a1 1 0 0 1-1.619-1.175l.955-1.316-1.542-.502a1 1 0 0 1 .619-1.902l1.54.501V4.5a1 1 0 0 1 1-1m-8.75 7.75a1 1 0 1 0-2 0v4.5a2.125 2.125 0 1 0 2 0zm-1 6.25a.125.125 0 1 0 0 .25.125.125 0 0 0 0-.25",
    clipRule: "evenodd"
  })));
};
export default SvgIconThermometerCold;